import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { PricingPageRoutes } from './PricingPageRoutes';
import { useInAppCurrencies } from './hooks/useCurrencyDetails';
import { SideNavContainer } from './side-nav/SideNavContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PricingPageApp = () => {
  useInAppCurrencies();
  return /*#__PURE__*/_jsxs(PPUIGrid, {
    inlineSize: "100%",
    maxInlineSize: "1330px",
    margin: "auto",
    marginBlockStart: "400",
    paddingInline: "200",
    gridTemplateAreas: "\n\". segmented-tabs\"\n\"side-nav content\"\n",
    gridTemplateColumns: "auto 1fr",
    rowGap: "400",
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "side-nav",
      children: /*#__PURE__*/_jsx(SideNavContainer, {})
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "content",
      marginInline: "1100",
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(PricingPageRoutes, {})
    })]
  });
};